export var AuditLogEntryType;
(function (AuditLogEntryType) {
    AuditLogEntryType["Policy"] = "Policy";
    AuditLogEntryType["User"] = "User";
    AuditLogEntryType["Organisation"] = "Organisation";
    AuditLogEntryType["Group"] = "Group";
    AuditLogEntryType["Contact"] = "Contact";
    AuditLogEntryType["Subscription"] = "Subscription";
    AuditLogEntryType["EmailTemplate"] = "EmailTemplate";
    AuditLogEntryType["InvoiceTag"] = "InvoiceTag";
    AuditLogEntryType["Invoice"] = "Invoice";
    // Need to record action, To track user actions like remove, ignore etc
    AuditLogEntryType["Action"] = "Action";
})(AuditLogEntryType || (AuditLogEntryType = {}));
//# sourceMappingURL=auditLog.js.map